/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Library_Coverage_MapInputs */

const en_landing_library_coverage_map = /** @type {(inputs: Landing_Library_Coverage_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client coverage map`)
};

/**
* | output |
* | --- |
* | "Client coverage map" |
*
* @param {Landing_Library_Coverage_MapInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_library_coverage_map = /** @type {((inputs?: Landing_Library_Coverage_MapInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Library_Coverage_MapInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_library_coverage_map(inputs)
});